<template lang="pug">
    dl.vacation
        dt(:class="vacation.status") Von {{ vacation.start | moment('DD.MM.YYYY') }}
        dd bis {{ vacation.end | moment('DD.MM.YYYY')}} - Tage: {{ vacation.used_days }}
        a.delete(@click="showConfirmation = true" v-if="canDeleteVacation")
        div.confirmation(v-if="showConfirmation") Diesen Urlaub wirklich löschen? &nbsp;
          button(@click="showConfirmation = false") nein
          button(@click="deleteVacation") ja

</template>

<script>
export default {
  name: 'vacation',
  props: ['vacation', 'user'],
  data () {
    return {
      showConfirmation: false,
      loginToken: this.$localStorage.get('loginToken')
    }
  },
  methods: {
    deleteVacation () {
      this.$http.delete('/vacations/' + this.vacation.id + '/').set({Authorization: 'jwt ' + this.loginToken})
        .accept('json')
        .then(res => {
          this.$emit('reload-vacations')
        }).catch(() => {
        })
    }
  },
  computed: {
    canDeleteVacation () {
      const isInTheFuture = new Date(this.vacation.start) > new Date()
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const createdToday = new Date(this.vacation.created) > today
      return isInTheFuture && (createdToday || this.user.freelancer)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">

dt, dd
  display: inline-block
  font-weight: normal
  margin-bottom: 1px
dt
  width: 120px
  border-left: 4px solid #eef12b
  padding-left: .8em
  &.accepted
    border-color: #83BC47
  &.denied
    border-color: #bc4755

button
  margin-right: 3px


.delete, .delete:hover
  float: right
  height: 18px
  width: 18px
  background-color: hsla(0,0%,4%,.1)

</style>



// WEBPACK FOOTER //
// Vacation.vue?76605022